import Route from '@ember/routing/route';
import { later, cancel } from '@ember/runloop';
import { inject as service } from '@ember/service';

export default class ClassGroupRoute extends Route 
{
	@service store;
	@service ajax;
	
	classGroupTimer = null
	classGroupRefreshInterval = 10000
	
	model(params) 
	{
		return this.store.peekRecord('class-group', params.classgroup_id);
	}
	
	async fetchClassGroups()
	{
		const classGroups = await this.ajax.request("class-groups");
		let type = this.store.modelFor('classGroup');
		let serializer = this.store.serializerFor('classGroup');
		this.store.push(serializer.normalizeArrayResponse(this.store, type, classGroups));
	}
	
	async fetchClassGroupsLoop()
	{
		cancel(this.classGroupTimer);
		this.classGroupTimer = later(this,async function()
		{			
			this.fetchClassGroups();
			this.fetchClassGroupsLoop();
		},this.classGroupRefreshInterval);
	}
	
	activate(transition)
	{
		this.fetchClassGroupsLoop();
	}
	
	deactivate(transition)
	{
		cancel(this.classGroupTimer);
	}
}
